import DeletingIndicator from './deleting-indicator';

export default DeletingIndicator;